export default __webpack_public_path__ + "static/media/carlosvalencia.af14abf1.jpg";